import { message } from 'antd'
import useFetchObject from '../../elements/Hooks/useFetchObject'
import useModalShow from '../../elements/Hooks/useModalShow'
import { isEmpty, pick } from 'lodash'
import { checkForm } from '../../modules/Utils'
import React, { useState } from 'react'

export const MODAL_TYPE_NEW = 'new'
export const MODAL_TYPE_EDIT = 'edit'
export default function useModalData(
  submitFunction,
  updateFunction,
  removeFunction,
  fetch,
  key,
  readFunction,
  submitRedirect,
  removeRedirect,
  payload = {}
) {
  const formRef = React.createRef()
  const { visible, onShow: showModal, onCancel: hideModal } = useModalShow()
  const [modalType, setModalType] = useState('new')
  const [submitting, setSubmitting] = useState(false)
  const [removing, setRemoving] = useState(false)

  const { fetch: fetchObject, fetching, object, setObject } = useFetchObject(
    () => readFunction(key),
    false,
    [key],
    isEmpty(key)
  )

  /** type : 'new' | 'edit' **/
  function onShow(newObject = {}, type = MODAL_TYPE_NEW) {
    if (type === MODAL_TYPE_NEW) newObject = {}
    setObject(newObject)
    showModal()
    setModalType(type)
  }

  function onCancel(isUpdated = false) {
    hideModal()
    setObject({})
    if (isUpdated === true) fetch()
  }

  async function update() {
    const updatedObject = await checkForm(formRef)
    setSubmitting(true)
    try {
      await updateFunction({
        ...updatedObject,
        ...pick(object, ['_id', '_key', '_rev']),
        ...payload,
      })
      onCancel()
      readFunction ? fetchObject() : fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function submit() {
    console.log('submit')
    const newObject = await checkForm(formRef)

    setSubmitting(true)
    try {
      const data = await submitFunction({ ...newObject })
      onCancel()
      submitRedirect && data ? submitRedirect(data._key) : fetch()

      message.success('Success')
      setSubmitting(false)
      return data
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      setSubmitting(false)
    }
  }

  async function remove() {
    setRemoving(true)
    try {
      await removeFunction({ ...pick(object, ['_id', '_rev', '_key']), ...payload })
      onCancel()
      removeRedirect ? removeRedirect() : fetch()

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setRemoving(false)
  }

  const isNew = modalType === 'new'

  return {
    visible,
    modalType,
    object,
    setObject,
    submitting,
    removing,
    setRemoving,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm: checkForm.bind(null, formRef),
    update,
    submit,
    remove,
    isNew,
    fetching,
    fetchObject,
  }
}
